// extracted by mini-css-extract-plugin
module.exports = {"container":"App_container___P6pN","desktop":"App_desktop__x6z8_"};